export const headerTestIds = {
  siteHeader: "site-header",
  headerNavigationItem: "header-nav-item",
  signInButton: "header-sign-in-button",
  myAccountLink: "header-my-account-btn",
  topNavigation: "header-top-navigation",
  basketButton: "header-basket-btn",
};
